import { z } from "zod";

export const categorySchema = z.object({
	id: z.string().optional(),
	case_type_id: z.string().optional(),
	case_category_id: z.string().optional(),
	created_at: z.string().optional(),
	updated_at: z.string().optional(),
	branchId: z.string().optional(),
});

export type Category = z.infer<typeof categorySchema>;
